import React from 'react';
import { pure, compose, withHandlers, withState } from 'recompose';
import SearchInput from '../SearchInput';
import DropdownList from './DropdownList';
import './SearchBox.css';

const SearchBox = ({
  usersItems,
  searchText,
  showDropdown,
  selectedIndex,
  handleKeyDown,
  onChange,
  onClear,
  onItemOver,
  onItemClick,
  onSearchClick,
}) => (
  <div className="SearchBox">
    <div className="inputBox">
      <SearchInput
        placeholder="Расклейщики и районы"
        value={searchText}
        onChange={onChange}
        onClear={onClear}
        onKeyDown={handleKeyDown}
      />
      <button onClick={onSearchClick}>Найти</button>
    </div>
    <div className={`dropdownBox${showDropdown ? '' : ' hide'}`}>
      <DropdownList
        items={usersItems}
        selectedIndex={selectedIndex}
        onItemOver={onItemOver}
        onItemClick={onItemClick}
      />
    </div>
  </div>
);

export default pure(compose(
  withState('selectedIndex', 'setSelectedIndex', -1),
  withHandlers({
    handleKeyDown: ({ usersItems, selectedIndex, setSelectedIndex, onSelect }) => event => {
      switch (event.keyCode) {
        // arrowup
        case 38:
          if (selectedIndex > 0) {
            setSelectedIndex(selectedIndex - 1);
          } else {
            setSelectedIndex(usersItems.length - 1);
          }
          event.preventDefault();
          break;

        // arrowdown
        case 40:
          if (selectedIndex < (usersItems.length - 1)) {
            setSelectedIndex(selectedIndex + 1);
          } else {
            setSelectedIndex(0);
          }
          event.preventDefault();
          break;

        // enter
        case 13:
          if (onSelect && selectedIndex >= 0 && selectedIndex < usersItems.length) {
            onSelect(usersItems[selectedIndex]);
          }
          break;
        default:
      }
    },
    onItemOver: ({ setSelectedIndex }) => index =>
      setSelectedIndex(index),
    onItemClick: ({ usersItems, selectedIndex, onSelect }) => () =>
      onSelect(usersItems[selectedIndex]),
    onSearchClick: ({ searchText, usersItems, onSelect }) => () =>
      searchText.trim().length > 0 && usersItems[0] && onSelect(usersItems[0]),
  }),
)(SearchBox));



// WEBPACK FOOTER //
// ./src/components/SearchBox/SearchBox.jsx